<template>
  <div style="width: 100%; height: calc(100vh - 300px)">
    <div :id="'dPlayer' + id" ref="player" style="width: 100%; height: 100%" class="dplayer video-box"></div>
  </div>
</template>
<script>
import Hls from "hls.js";
import VueDPlayer from "vue-dplayer";
import DPlayer from "dplayer";
import "vue-dplayer/dist/vue-dplayer.css";

export default {
  name: "YrHgyVPlayer",
  components: {
    "d-player": VueDPlayer,
  },
  props: {
    id: {
      type: [String, Number],
    },
    courseId: {
      type: [String, Number],
    },
    url: {
      type: String
    },
  },
  data() {
    return {
      dp: {},
    };
  },
  watch: {
    url: {
      handler(newval, oldval) {
        if (newval) {
          this.$nextTick(() => {
            this.initVideo(newval, this.id);
          })
        }
      },
      deep: true,
    },
  },
  mounted() {

  },
  methods: {
    initVideo(val, id) {
      let domId = "dPlayer" + id;
      this.dp = new DPlayer({
        //播放器的一些参数
        container: document.getElementById(domId),
        video: {
          url: val, //视频地址
          type: "customHls",
          customType: {
            customHls: function (video, player) {
              const hls = new Hls(); //实例化Hls  用于解析m3u8
              hls.loadSource(video.src);
              hls.attachMedia(video);
            },
          },
        },
        autoplay: false, //是否自动播放
        theme: "#FADFA3", //主题色
        loop: false, //视频是否循环播放
        lang: "zh-cn",
        logo: 'https://cloudcache.tencent-cloud.com/qcloud/ui/static/portal_producticon_v2/1e18c4a6-a30b-4136-aaa7-86ad0993958e.svg',
        screenshot: false, //是否开启截图
        hotkey: true, // 是否支持热键，调节音量，播放，暂停等
        preload: "auto", // 自动预加载
        volume: 0.7, // 初始化音量
        playbackSpeed: [0.5, 0.75, 1, 1.25, 1.5, 2, 3], //可选的播放速度，可自定义
        contextmenu: [],
        highlight: [],
        mutex: true, //阻止多个播放器同时播放，当前播放器播放时暂停其他播放器
      });
      let _this = this
      let lastTime = ''
      this.dp.on('timeupdate', function () {
        console.log('播放进度更新',_this.dp.video.currentTime)
        const currentTime = _this.dp.video.currentTime
        const duration = _this.dp.video.duration;
        // 5秒触发一次
        if(currentTime % 5 === 0 || !lastTime){
          _this.doView(_this.dp.video.currentTime,duration)
          lastTime = +new Date()
        }
        if(+new Date() - lastTime > 5000){
          _this.doView(currentTime,duration)
          lastTime = +new Date()
        }
      })
      this.dp.on('ended', function () {
        console.log('结束',_this.dp.video.currentTime)
        const currentTime = _this.dp.video.currentTime
        const duration = _this.dp.video.duration;
        _this.doView(currentTime,duration)
      })
    },
    doView(time,duration){
      console.log("看视频记录")
      $cloud.post("/record/view/record", {courseId: this.courseId,fileId:this.id,time,duration}).then(() => {
        console.log('添加')
      })
    }
  },

};
</script>
<style lang="scss">

.video-box {
  width: 100%;
  height: 100%;
}
</style>
